import './styles.scss';

import { useTable } from '@refinedev/core';
import { Table } from 'antd';
import { useTranslation } from 'react-i18next';

import { IReport } from '../../interfaces/report';
import { convertPrice } from '../../utils/resource';

const REPORT_RESOURCE_URL = 'v1/report';

export const OverdueInvoiceIndex: React.FC = () => {
    const { tableQueryResult } = useTable<IReport.IOverdueInvoice>({
        resource: `${REPORT_RESOURCE_URL}/overdue-invoice`,
        hasPagination: false,
    });

    const { t } = useTranslation(['common']);

    return (
        <>
            <section className="item-list-container quote-page-wrapper mb-10">
                <div className="overflow-hidden">
                    <h3 className="title-section"> {t(`reports.overdue-invoice`)}</h3>
                    <div className="list-content table-wrapper">
                        <Table
                            dataSource={tableQueryResult?.data?.data}
                            loading={tableQueryResult.isFetching}
                            pagination={false}
                            rowKey="id"
                            className="overdue-invoice-table"
                            showHeader={false}
                            scroll={{ x: '599px', y: '100%' }}
                        >
                            <Table.Column
                                dataIndex="dateRange"
                                key="dateRange"
                                render={(text, _: IReport.IOverdueInvoice) => (
                                    <p className="table-tbody-text">
                                        {t(`reports.${_.dateRange}`)}
                                    </p>
                                )}
                            />
                            <Table.Column
                                dataIndex="total"
                                key="total"
                                render={(text, _: IReport.IOverdueInvoice) => (
                                    <p className="table-tbody-text">{convertPrice(_.total)}</p>
                                )}
                            />
                        </Table>
                    </div>
                </div>
            </section>
        </>
    );
};
